import * as React from 'react';
import {cva, type VariantProps} from 'class-variance-authority';

import {cn} from '@/lib/utils';

const bodyVariants = cva('text-font-color-1', {
  variants: {
    variant: {
      large: 'text-[18px] leading-[1.5rem] font-normal -tracking-[0.5px]',
      bold: 'text-[1rem] leading-[1.5rem] font-bold',
      regular: 'text-[1rem] leading-[1.5rem] font-normal',
      small: 'text-[0.875rem] leading-[1.5rem] font-bold',
    },
  },
  defaultVariants: {
    variant: 'regular',
  },
});

export interface BodyProps
  extends React.BaseHTMLAttributes<HTMLParagraphElement>,
    VariantProps<typeof bodyVariants> {}

const Body = React.forwardRef<HTMLParagraphElement, BodyProps>(
  ({className, variant, ...props}, ref) => {
    return (
      <p
        className={cn(bodyVariants({variant, className}))}
        ref={ref}
        {...props}
      />
    );
  },
);
Body.displayName = 'Body';

export {Body, bodyVariants};
